import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Space,
    Tabs,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  import { connect } from "react-redux";
  // import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
  import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    RangePickerItem,
    TableItem,
    dineroDisabledMask,
    ButtonItem,
    ErrorItem
  } from "../../../../Components/Items";
  import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
  import * as XLSX from "xlsx";
  import { ResponsiveLine } from "@nivo/line";
  import moment from "moment";
  import "moment/locale/es";
import reporteDeReposicionCajaChicaPdf from "../../../../Pdf/reporteDeReposicionCajaChicaPdf";
  moment.locale("es");
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
  const { Option } = Select;
  const { TabPane } = Tabs;
  
  class ReporteReposicionCajaChica extends Component {
    state = {
      loading: false,
      pdf: null,
      objetoCajaEfectivo: null,
      todasCajaEfectivo: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoUniadesDeNegocio: null,
      todasUniadesDeNegocio: null,
      dataReporte: null,
      todosPagos: [],
      dataGrafico: [],
      total: 0,
    };
  
    atras() {
        this.props.history.goBack();
    }
  
    async componentDidMount() {
      this.setState({ loading: true });

      let primeraCuentaCEId = undefined

      await axios
        .post(
          "cajaEfectivo/selectCajaEfectivo",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            primeraCuentaCEId = res.data[0] ? res.data[0]._id : undefined 
            this.setState({ todasCajaEfectivo: res.data });
            this.setState({
              objetoCajaEfectivo: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.banco}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUniadesDeNegocio: res.data });
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
        
        if(primeraCuentaCEId){
          this.consultarReporteReposicionCajaChica({
            cajasChicas: [],
            periodo: [moment().subtract(1, "month"), moment()],
            filtrarProyecto: 0,
          });
        }else{
          this.setState({loading: false})
        }
    }
  
    async crearGrafico(valuePagos, fechaInicial, fechaFinal) {
      let grafico = [];
      let graficoSumatoria = [];
      let sumatoria = 0;
  
      let fechaCambiante = moment(fechaInicial).locale("es");
      const fechaFinalMoment = moment(fechaFinal).locale("es");
  
      if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
        while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago) && todosPagos.cajaChica !== "") {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "date"
              );
            } else {
              return false;
            }
          });
  
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
        while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago) && todosPagos.cajaChica !== "") {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "week"
              );
            } else {
              return false;
            }
          });
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
        while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago) && todosPagos.cajaChica !== "") {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "month"
              );
            } else {
              return false;
            }
          });
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
        }
      } else {
        while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
          // eslint-disable-next-line no-loop-func
          const pagos = valuePagos.filter((todosPagos) => {
            if (isNaN(todosPagos.fechaPago) && todosPagos.cajaChica !== "") {
              return moment(fechaCambiante).isSame(
                moment(todosPagos.fechaPago, "DD/MM/YYYY"),
                "year"
              );
            } else {
              return false;
            }
          });
          let total = 0;
  
          pagos.map((pagosDia) => {
            total += pagosDia.monto;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: total + sumatoria,
          });
  
          sumatoria += total;
          fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
        }
      }
  
      await this.setState({
        dataGrafico: [
          {
            id: "Pagos",
            color: "hsl(15, 70%, 50%)",
            data: grafico,
          },
          {
            id: "Pagos Acumulados",
            color: "hsl(15, 70%, 50%)",
            data: graficoSumatoria,
          },
        ],
      });
    }
  
    consultarReporteReposicionCajaChica(values) {
      this.setState({ loading: true });
      axios
        .post(
          "reportesAdministrativos/reporteReposicionCajaChica",
          { ...values, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.crearGrafico(
              res.data.pagos,
              res.data.fechaInicial,
              res.data.fechaFinal
            );
            this.setState({
              loading: false,
              dataReporte: res.data,
              todosPagos: res.data.pagos,
              total: res.data.total,
            });
          } else if (res.data.success === 1) {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          } else {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          }
          this.setState({ loading: false });
        });
    }
  
    descargarExcel() {
      let datosDescargar = []
        datosDescargar = this.state.todosPagos.map((valuePago) => {
          return {
            "Caja Chica": valuePago.cajaChica,
            Banco: valuePago.banco,
            Fecha: valuePago.fechaPago,
            Proyecto: valuePago.proyecto,
            Moneda: valuePago.moneda,
            Monto: valuePago.monto,
            Referencia: valuePago.referencia
          };
        });
      const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Reposicion");
      //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workbook, `Reporte_De_Reposicion_${moment().locale("es").format("L")}.xlsx`);
    }
  
    descargarPdf() {
      pdfMake
        .createPdf(reporteDeReposicionCajaChicaPdf(this.state.dataReporte))
        .download(`Reporte_De_Reposicion_${moment().locale("es").format("L")}`);
    }
  
    onFinishFailed(e) {
      ErrorItem(e);
    }
    
    render() {
      const columns = [
        {
          title: "Caja Chica",
          dataIndex: "cajaChica",
          key: "cajaChica",
          sorter: (a, b) => {
            if (a.cajaChica < b.cajaChica) {
              return -1;
            }
            if (a.cajaChica > b.cajaChica) {
              return 1;
            }
            return 0;
          },
          buscar: "cajaChica",
          ellipsis: true,
        },
        {
          title: "Banco",
          dataIndex: "banco",
          key: "banco",
          sorter: (a, b) => {
            if (a.banco < b.banco) {
              return -1;
            }
            if (a.banco > b.banco) {
              return 1;
            }
            return 0;
          },
          buscar: "banco",
          ellipsis: true,
        },
        {
          title: "Fecha",
          dataIndex: "fechaPago",
          key: "fechaPago",
          sorter: (a, b) => {
            if (moment(a.fechaPago, "DD/MM/YYYY") < moment(b.fechaPago, "DD/MM/YYYY")) {
              return -1;
            }
            if (moment(a.fechaPago, "DD/MM/YYYY") > moment(b.fechaPago, "DD/MM/YYYY")) {
              return 1;
            }
            return 0;
          },
          buscar: "fechaPago",
          ellipsis: true,
        },
        {
          title: "Proyecto",
          dataIndex: "proyecto",
          key: "proyecto",
          sorter: (a, b) => {
            if (a.proyecto < b.proyecto) {
              return -1;
            }
            if (a.proyecto > b.proyecto) {
              return 1;
            }
            return 0;
          },
          buscar: "proyecto",
          ellipsis: true,
        },
        {
          title: "Moneda",
          dataIndex: "moneda",
          key: "moneda",
          sorter: (a, b) => {
            if (a.moneda < b.moneda) {
              return -1;
            }
            if (a.moneda > b.moneda) {
              return 1;
            }
            return 0;
          },
          buscar: "moneda",
          ellipsis: true,
        },
        {
          title: "Monto",
          dataIndex: "monto",
          key: "monto",
          sorter: (a, b) => {
            if (a.monto < b.monto) {
              return -1;
            }
            if (a.monto > b.monto) {
              return 1;
            }
            return 0;
          },
          buscar: "monto",
          render: (value) => dineroDisabledMask(value),
          align: "right",
          ellipsis: true,
        },
        {
          title: "Referencia",
          dataIndex: "referencia",
          key: "referencia",
          sorter: (a, b) => {
            if (a.referencia < b.referencia) {
              return -1;
            }
            if (a.referencia > b.referencia) {
              return 1;
            }
            return 0;
          },
          buscar: "referencia",
          ellipsis: true,
        },
      ];
      return (
        <>
          <Form
            ref={this.formRef}
            name="reporteReposicionCajaChica"
            onFinish={this.consultarReporteReposicionCajaChica.bind(this)}
            onFinishFailed={this.onFinishFailed}
            initialValues={{
              periodo: [moment().subtract(1, "month"), moment()],
            }}
          >
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Reporte Reposicion Caja Chica"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
              extra={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcel()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF
                      </ButtonItem>
                    )}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Consultar
                    </ButtonItem>
                  </Space>
                </div>
              }
            />
            <Spin spinning={this.state.loading}>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingTop: 5,
                  marginBottom: 20,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Tabs
                  style={{ margin: 0 }}
                  tabBarExtraContent={{
                    left: (
                      <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                        Filtros:
                      </h1>
                    ),
                  }}
                >
                  <TabPane tabKey="2" key="2" forceRender tab="Cajas Chicas">
                    <FormItem name="cajasChicas" noStyle margin>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Cajas Chicas"
                      >
                        {this.state.objetoCajaEfectivo}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                    <FormItem name="periodo" required noStyle>
                      <RangePickerItem />
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                    <Row>
                      <Col span={8}>
                        <FormItem
                          name="filtrarProyecto"
                          required
                          noStyle
                          initialValue={0}
                        >
                          <SelectItem width="90%" placeholder="Filtrar Proyecto">
                            <Option default value={0}>
                              Niguno
                            </Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto =
                              getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" margin noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Proyectos"
                                    mode="multiple"
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem required margin name="unidadDeNegocioId" noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Unidades de Negocio"
                                  >
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                </Tabs>
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingBottom: 35,
                  marginTop: 10,
                  marginBottom: 10,
                  height: 420,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Gráfico</h1>

                <ResponsiveLine
                  data={this.state.dataGrafico}
                  margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                  // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                  enableSlices="x"
                  useMesh={true}

                  yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: 0,
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}

                  curve="monotoneX"
                  lineWidth={2}

                  // ✅ Menos ruido visual
                  pointSize={5}
                  pointBorderWidth={1}
                  pointColor={{ theme: "background" }}
                  pointBorderColor={{ from: "serieColor" }}

                  // Si quieres aún más limpio, descomenta:
                  // enablePoints={false}

                  colors={["#ff6633", "#FF926E"]}
                  colorBy="index"

                  axisTop={null}
                  axisRight={null}

                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 8,
                    tickRotation: 45,
                    // ✅ muestra menos etiquetas (una de cada 2 o 3)
                    tickValues: (this.state.dataGrafico?.[0]?.data || [])
                      .map(d => d.x)
                      .filter((_, i) => i % 2 === 0),
                  }}

                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 8,
                    format: (v) => dineroDisabledMask(Math.abs(v)),
                  }}

                  // ✅ Grid más limpio
                  enableGridX={false}

                  legends={[
                    {
                      anchor: "top-right",
                      direction: "column",
                      translateX: 0,
                      translateY: 0,
                      itemWidth: 130,
                      itemHeight: 18,
                      symbolSize: 10,
                      symbolShape: "circle",
                      itemOpacity: 0.85,
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
              <TableItem
                rowKey={(value) => value._id.toString() + Math.random()}
                columns={columns}
                dataSource={this.state.todosPagos}
                size="small"
                pagination={false}
              />
              {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
            </Spin>
          </Form>
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(ReporteReposicionCajaChica);
  